import axios from "axios";

const getDefaultState = () => {
    return {
        isAppLoading: false,
        routesNoLoading: [
            '/users/checkIfEmailExist',
            '/logout',
            '/404',
            '/403'
        ]
    }
}

export const state = getDefaultState();

export const actions = {
    initRoutesNotLoading: ({ commit }) => {
        commit('INIT_ROUTES_NO_LOADING');
    },
    setAppAsLoading: ({ commit }) => {
        commit('APP_IS_LOADING');
    },
    setAppAsReady: ({ commit }) => {
        commit('APP_IS_READY');
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async sendEmail({commit}, payload) {
        await axios.post(`fastmarket/app/sendEmail`, {...payload});
        return true;
    },
}

export const mutations = {
    APP_IS_LOADING: state => state.isAppLoading = true,
    APP_IS_READY: state => state.isAppLoading = false,
    INIT_ROUTES_NO_LOADING: state => state.routesNoLoading = getDefaultState().routesNoLoading,
};
